import React, { memo, useState } from 'react';
import { useDescrizioniScommesse, useInfoTipoList, usePlayers } from 'features/sport/hooks';

import { ItemWithTranslation } from 'types/swagger';
import { ScommesseMarcatoriRender } from '../sportMarcatoriRender';
import { ScommesseTableTabs } from 'components/scommesseTable/scommesseTableTabs';
import { ScommesseTableTitle } from 'components/scommesseTable/scommesseTableTitle';
import { SkeletonArea } from 'components/skeletonArea';
import { SportMarcatoriTableRow } from '../sportMarcatoriTableRow';
import { SportTableScommesseHeadersSticky } from '../sportTableScommesse/sportTableScommesseHeadersSticky';
import { TooltipPosition } from 'components/tooltip';
import classNames from 'classnames';
import { isTruthy } from 'utility/functions';
import { selectIsOpenCarrello } from 'features/carrello/carrelloSelectors';
import styles from './SportMarcatoriTableScommesse.module.scss';
import { useTypedSelector } from 'lib/centralStore';
import useWindowSize from 'hooks/useWindowSize';

export interface SportAvvenimentoType {
  key: string;
  firstPriority: string;
}

export type SportMarcatoriTableScommesseProps = ItemWithTranslation<{ title?: string; gruppo?: string }> & {
  infoTipoScommessaKeyList: string[];
  hasHeaderScommessa?: boolean;
  hasBorderSide?: boolean;
  showTableTitle?: boolean;
  isManifestazioneTemplate?: boolean;
  showTitle?: boolean;
  isTopTemplate?: boolean;
  isFirstAvvenimento?: boolean;
  hasMultipleLines?: boolean;
  selectedIndexInfoTipoScommessa?: number;
  showOnlyBilanciata?: boolean;
  className?: string;
  sortAvvenimenti?: boolean;
  statePath?: string[];
  iconSrc?: string;
  isPrincipaliFilter?: boolean;
  gtagAction?: () => void;
};

export const SportMarcatoriTableScommesse = memo(function SportMarcatoriTableScommesse({
  infoTipoScommessaKeyList,
  showTableTitle,
  isManifestazioneTemplate,
  isTopTemplate,
  selectedIndexInfoTipoScommessa,
  className,
  isPrincipaliFilter,
}: SportMarcatoriTableScommesseProps) {
  const isOpen = useTypedSelector(selectIsOpenCarrello);
  const { isMobile } = useWindowSize();
  const descrizioni = useDescrizioniScommesse(infoTipoScommessaKeyList);
  const { infoTipoScommessaList } = useInfoTipoList(infoTipoScommessaKeyList);
  const [selectedMobileTipoScommessa, setSelectedMobileTipoScommessa] = useState(0);
  const infoTipoScommessa = infoTipoScommessaList[selectedIndexInfoTipoScommessa ?? selectedMobileTipoScommessa];
  const playersKeys = usePlayers(infoTipoScommessaKeyList);

  return (
    <div className={classNames(styles.table, className, { [styles.isOpen]: isOpen })}>
      {showTableTitle && infoTipoScommessaKeyList?.length > 1 && (
        <ScommesseTableTabs
          activeIndex={selectedMobileTipoScommessa}
          descriptions={descrizioni}
          onSelectedItem={(selectedTipoScommessaIndex) => {
            setSelectedMobileTipoScommessa(selectedTipoScommessaIndex);
          }}
        />
      )}
      <SportTableScommesseHeadersSticky
        isInfoAggVisible
        isSubHeaderVisible={infoTipoScommessaKeyList.length === 1}
        infoTipoScommessaKeyList={infoTipoScommessaKeyList}
        className={classNames({ [styles.hidden]: isMobile })}
      />
      {isTruthy(playersKeys?.length) &&
        playersKeys.map((playerKey, index) => {
          const { descrizione: labelDx, descrizioneTrKey: labelDxTrKey } =
            descrizioni?.[selectedIndexInfoTipoScommessa ?? selectedMobileTipoScommessa] ?? {};

          return infoTipoScommessaKeyList && infoTipoScommessa ? (
            <React.Fragment key={`${playerKey}-${index}`}>
              {isManifestazioneTemplate && (
                <ScommesseTableTitle
                  labelDx={labelDx}
                  labelDxTrKey={labelDxTrKey}
                  className={classNames({ [styles.alignToLeft]: !isTopTemplate, [styles.hidden]: !isMobile })}
                  tooltipText={infoTipoScommessa?.toolTip}
                  tooltipTextTrKey={infoTipoScommessa?.toolTipTrKey}
                  tooltipPosition={isMobile ? TooltipPosition.BOTTOM_LEFT : TooltipPosition.BOTTOM}
                />
              )}
              <SportMarcatoriTableRow hasBorderTop playerKey={playerKey}>
                <ScommesseMarcatoriRender
                  infoTipoScommessaKeyList={infoTipoScommessaKeyList}
                  playerKey={playerKey}
                  showMultipleBox={infoTipoScommessaKeyList.length === 1}
                  isPrincipaliFilter={isPrincipaliFilter}
                  hasHeader={isMobile}
                />
              </SportMarcatoriTableRow>
            </React.Fragment>
          ) : (
            <SkeletonArea className={styles.skeletonRow} key={`skeleton-${index}`} />
          );
        })}
    </div>
  );
});
